import ELID from 'constants/elid.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('updateIntercomElement');

const FTAG = 'updateIntercomElement()';

const shortError = (error) => error?.message ?? error;

const updateIntercomElement = (options) => {
  const show = options?.show;
  const tag = fromAnyToTrimmed(options?.tag);

  let intercomElement;
  try {
    intercomElement = document.getElementById(ELID.intercom);
    if (intercomElement) {
      intercomElement.style.visibility = show ? 'visible' : 'hidden';
      return intercomElement;
    }

    if (tag) {
      L.info(FTAG, tag, 'show:', show, 'Missing intercomElement:', intercomElement);
    } else {
      L.warn(FTAG, 'no tag', 'show:', show, 'Missing intercomElement:', intercomElement);
    }

    return intercomElement;
  } catch (e) {
    if (tag) {
      L.error(FTAG, tag, 'show:', show, 'error:', shortError(e));
    } else {
      L.error(FTAG, 'no tag', 'show:', show, 'error:', e);
    }
  }

  return intercomElement;
};

// noinspection JSUnusedGlobalSymbols
export default updateIntercomElement;
